const { InspectorControls } = wp.blockEditor;
const { PanelBody, TextControl, SelectControl, ToggleControl } = wp.components;
import CommonPanel from '../wp-controlers/common-panel';

export default function Inspector({ attributes, setAttributes }) {
  const { title, subtitle, hasSubtitle, textPosition, btnText, formId } =
    attributes;

  return (
    <InspectorControls>
      <PanelBody title="Formulário Curto" initialOpen={true}>
        <TextControl
          label="Título do Forms"
          value={title}
          onChange={(value) => setAttributes({ title: value })}
        />

        <ToggleControl
          label="Adicionar subtítulo?"
          checked={hasSubtitle}
          onChange={() => setAttributes({ hasSubtitle: !hasSubtitle })}
        />

        {hasSubtitle && (
          <TextControl
            label="Subtítulo do Forms"
            value={subtitle}
            onChange={(value) => setAttributes({ subtitle: value })}
          />
        )}

        <SelectControl
          label="Selecione o posicionamento do texto"
          title="Selecione o posicionamento do texto"
          value={textPosition}
          options={[
            { label: 'No centro', value: 'center' },
            { label: 'Em cima', value: 'top' },
            { label: 'Em baixo', value: 'bottom' },
          ]}
          onChange={(position) => setAttributes({ textPosition: position })}
        />

        <TextControl
          label="Texto do Botão"
          value={btnText}
          onChange={(value) => setAttributes({ btnText: value })}
        />

        <TextControl
          label="Crie um identificador ÚNICO para este form"
          value={formId}
          onChange={(value) => setAttributes({ formId: value })}
        />
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
}
